module.exports = __webpack_public_path__ + "img/exclamation-experian.228522c1.svg";